<template>
    <div class="lang-change">
      <!-- Desktop Dropdown -->
      <select
        class="product-select has-value"
        :class="{
					        'dark-product-select': isDarkBGRouteSet 
                }"
        v-model="selectedOption" @change="goToPage">
        <option disabled value="" v-if="!selectedOption" v-show="false">{{ $t('navigation_links_products') }}</option>
        <option v-for="(item, key) in options" :key="key" :value="key">
          {{ item.label }}
        </option>
      </select>
  
      <!-- Mobile/Portrait Links -->
      <div class="products-links" >
        <a 
        :class="{
					        'dark-product-select': isDarkBGRouteSet 
                }" v-for="(item, key) in options" :key="key" :href="getPath(item.path)" class="nuxt-link">{{ item.label }}</a>
      </div>
    </div>
  </template>
  
  <script>
	import { Events } from '../utils/analytics';
  export default {
    data() {
      return {
        selectedOption: '',
        options: {},
        websiteUrl: process.env.VUE_APP_WEBSITE_URL,
        whiteBgRoutes: ['products'],
        darkBgRoutes: ['profile'],
        excludedLang: ['ar', 'it', 'pt', 'en']
      };
    },
    computed: {
        currentRoute() {
            return this.$route.name;
        },
        isWhiteBackgroundSet() {
            return this.whiteBgRoutes.includes(this.currentRoute);
        },
        isDarkBGRouteSet() {
            return this.darkBgRoutes.includes(this.currentRoute);
        },
    },
    created() {
      this.options = {
        tv: {
          label: this.$t('navigation_links_products_tv'),
          path: 'kidjo-tv'
        },
        books: {
          label: this.$t('navigation_links_products_books'),
          path: 'kidjo-stories'
        },
        games: {
          label: this.$t('navigation_links_products_games'),
          path: 'kidjo-games'
        }
      };
    },
    methods: {
      goToPage() {
        const selectedPath = this.options[this.selectedOption]?.path;
        if (!selectedPath) return;
  
        // const locale = this.$i18n.locale;
        // const path = locale === 'en' ? `/${selectedPath}` : `/${locale}/${selectedPath}`;
        // this.$store.dispatch('postAnalytics', Events.EXIT);
        window.location.href =  this.ifInExcludedLang() ? this.websiteUrl + `/${selectedPath}` : this.websiteUrl + `/${this.$i18n.locale}/${selectedPath}`;
      },
      getPath(path) {
        return this.ifInExcludedLang() ? this.websiteUrl + `/${path}` : this.websiteUrl + `/${this.$i18n.locale}/${path}`;
      },
      ifInExcludedLang () {
          return this.excludedLang.includes(this.$i18n.locale);
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .lang-change {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-family: "Nunito-ExtraBold";
    font-size: 14px;
  }
  .dark-product-select {
    background-color: #020076 !important;
    color: white !important;
    
  }
  .product-select {
    padding: 0.5rem;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    background-color: #fff;
    color: #020076;
    font-family: 'Nunito-ExtraBold', Arial, sans-serif;

    @media (max-width: 830px ) {
      font-size: 11px; 
    }
  }
  
  .nuxt-link {
    text-decoration: none;
    color: #020076;
    transition: all 0.3s ease;
    font-size: 14px;
    font-family: 'Nunito-ExtraBold', Arial, sans-serif;

    @media (max-width: 830px ) {
      font-size: 11px; 
    }
  }
  
//   .nuxt-link:hover {
//     background-color: #f0f0f0;
//     border-color: #ccc;
//   }
  
  .products-links {
    display: none;
  
    @media (orientation: portrait) {
      display: flex;
      flex-direction: row;
      gap: 10px;
    }
  }
  
  @media (orientation: portrait) {
    .product-select {
      display: none;
    }
  }
.portrait-display {
    display: none;
}
@media (orientation: portrait) {
    .center-link {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
    .locale-display {
        display: flex;
        flex-direction: row;
    }
    .hide-portrait {
        display: none;
    }
    .portrait-display {
        display: flex;
        flex-direction: row;
    }
}
  </style>
  